export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "talk-JitsiStreamBackgroundEffect.worker.worker.js?v=cb7265b228c08eb52f52");
}
